import { IEvent } from "./Event";
import { injectable } from "inversify";
import "reflect-metadata";

@injectable()
export default class WindowEvent implements IEvent {
  dispatchEvent(event: string): void {
    const currentEvent = new Event(event);

    window.dispatchEvent(currentEvent);
  }

  removeEvent(event: string, handler: () => void): void {
    window.removeEventListener(event, handler);
  }

  listenEvent(event: string, handler: () => void): void {
    window.addEventListener(event, handler);
  }
}
